import {BagSvg} from './BagSvg';
import {WaySvg} from './WaySvg';
import {OpenSvg} from './OpenSvg';
import {ListSvg} from './ListSvg';
import {LogoSvg} from './LogoSvg';
import {CardSvg} from './CardSvg';
import {GiftSvg} from './GiftSvg';
import {CopySvg} from './CopySvg';
import {StarSvg} from './StarSvg';
import {PlusSvg} from './PlusSvg';
import {MailSvg} from './MailSvg';
import {EditSvg} from './EditSvg';
import {LineSvg} from './LineSvg';
import {TruckSvg} from './TruckSvg';
import {CheckSvg} from './CheckSvg';
import {HeartSvg} from './HeartSvg';
import {MinusSvg} from './MinusSvg';
import {TicketSvg} from './TicketSvg';
import {LogOutSvg} from './LogOutSvg';
import {GoogleSvg} from './GoogleSvg';
import {GoBackSvg} from './GoBackSvg';
import {BasketSvg} from './BasketSvg';
import {MapPinSvg} from './MapPinSvg';
import {EyeOffSvg} from './EyeOffSvg';
import {TwitterSvg} from './TwitterSvg';
import {FiltersSvg} from './FiltersSvg';
import {FaceBookSvg} from './FaceBookSvg';
import {CalendarSvg} from './CalendarSvg';
import {HeartBigSvg} from './HeartBigSvg';
import {CanceledSvg} from './CanceledSvg';
import {AgeCheckSvg} from './AgeCheckSvg';
import {OpenArrowSvg} from './OpenArrowSvg';
import {AddToCartSvg} from './AddToCartSvg';
import {BriefcaseSvg} from './BriefcaseSvg';
import {SortingBySvg} from './SortingBySvg';
import {ModalMailSvg} from './ModalMailSvg';
import {OrderPlusSvg} from './OrderPlusSvg';
import {PhoneCallSvg} from './PhoneCallSvg';
import {SearchHeaderSvg} from './SearchSvg';
import {DeliveredSvg} from './DeliveredSvg';
import {HeaderLogoSvg} from './HeaderLogoSvg';
import {CreditCardSvg} from './CreditCardSvg';
import {HelpCircleSvg} from './HelpCircleSvg';
import {RightArrowSvg} from './RightArrowSvg';
import {OrderMinusSvg} from './OrderMinusSvg';
import {AddANewCardSvg} from './AddANewCardSvg';
import {RepeatOrderSvg} from './RepeatOrderSvg';
import {HomeAddressSvg} from './HomeAddressSvg';
import {PaymentPlusSvg} from './PaymentPlusSvg';
import {PaymentCheckSvg} from './PaymentCheckSvg';
import {NewPromocodeSvg} from './NewPromocodeSvg';
import {AddANewAddresSvg} from './AddANewAddresSvg';
import {MapPinSvgAddress} from './MapPinSvgAddress';
import {RememberCheckSvg} from './RememberCheckSvg';
import {CheckPromocodeSvg} from './CheckPromocodeSvg';
import {BestSellerHeartSvg} from './BestSellerHeartSvg';

// Tab Icons
import {HomeSvg} from './tabs/HomeSvg';
import {OrderSvg} from './tabs/OrderSvg';
import {SearchSvg} from './tabs/SearchSvg';
import {ProfileSvg} from './tabs/ProfileSvg';
import {WishlistSvg} from './tabs/WishlistSvg';

export const svg = {
  BagSvg,
  WaySvg,
  HomeSvg,
  ListSvg,
  CardSvg,
  GiftSvg,
  EditSvg,
  CopySvg,
  LogoSvg,
  StarSvg,
  PlusSvg,
  MailSvg,
  LineSvg,
  OpenSvg,
  MinusSvg,
  OrderSvg,
  HeartSvg,
  TruckSvg,
  CheckSvg,
  TicketSvg,
  BasketSvg,
  SearchSvg,
  MapPinSvg,
  GoogleSvg,
  EyeOffSvg,
  GoBackSvg,
  LogOutSvg,
  FiltersSvg,
  TwitterSvg,
  ProfileSvg,
  FaceBookSvg,
  CalendarSvg,
  AgeCheckSvg,
  CanceledSvg,
  WishlistSvg,
  HeartBigSvg,
  OpenArrowSvg,
  DeliveredSvg,
  AddToCartSvg,
  OrderPlusSvg,
  PhoneCallSvg,
  BriefcaseSvg,
  SortingBySvg,
  ModalMailSvg,
  HeaderLogoSvg,
  CreditCardSvg,
  OrderMinusSvg,
  HelpCircleSvg,
  RightArrowSvg,
  HomeAddressSvg,
  AddANewCardSvg,
  PaymentPlusSvg,
  RepeatOrderSvg,
  SearchHeaderSvg,
  PaymentCheckSvg,
  NewPromocodeSvg,
  MapPinSvgAddress,
  AddANewAddresSvg,
  RememberCheckSvg,
  CheckPromocodeSvg,
  BestSellerHeartSvg,
};
